// ─────────────────────────────────────────────
// i18n — 5言語翻訳データ
// ─────────────────────────────────────────────
const translations = {
  JP: {
    // AppShell
    gov: "池本市　デジタル市役所",
    sub: "IKEMOTO CITY DIGITAL GOVERNMENT",
    // タブ
    tab_board: "掲示板", tab_market: "商業区", tab_gov: "行政", tab_proc: "手続き", tab_my: "マイページ",
    // BoardScreen
    board_title: "共創掲示板", board_sub: "Co-creation Board",
    board_note: "本掲示板への参加は、スキルの参加申請によってのみ行われます。",
    board_msg_tab: "メッセージ", board_board_tab: "掲示板",
    board_assign_btn: "参加申請する", board_room_btn: "プロジェクトルームへ",
    board_closed: "このプロジェクトは募集を締め切りました",
    board_my_msg: "MY PROJECT MESSAGES", board_no_room: "参加中のプロジェクトルームはありません",
    board_no_room_sub: "掲示板からプロジェクトに参加申請するとこちらにメッセージルームが表示されます",
    board_back: "← 掲示板へ戻る", board_chat_to: "チャットへ →",
    // MarketScreen
    market_list_title: "商業区　店舗一覧", market_shops: "店舗",
    market_items: "点", market_go: "店舗を見る →", market_back: "← 店舗一覧",
    market_assets: "取扱作品", market_report_title: "店舗を通報",
    market_report_send: "送信", market_report_done: "通報を受け付けました",
    market_report_done_sub: "内容を確認の上対処いたします。",
    market_follow: "フォロー", market_following: "フォロー中",
    market_like: "...", market_liked: "いいね済",
    market_report: "通報する", market_block: "ブロックする",
    market_price: "登録価格",
    // GovScreen
    gov_title: "行政情報", gov_sub: "Administration",
    gov_treasury: "財務状況", gov_citizens: "市民統計",
    // ProcScreen
    proc_title: "行政手続き", proc_sub: "Procedures",
    proc_apply: "申請する", proc_status: "申請状況",
    // MyScreen
    my_title: "マイページ", my_settings: "パラメータ設定",
    my_logout: "ログアウト", my_following: "フォロー中",
    my_liked: "いいね済み", my_blocked: "ブロックリスト",
    my_liked_shops: "いいね済み店舗", my_liked_items: "いいね済み作品",
    my_inquiry: "行政への意見具申",
    // 共通
    back: "← 戻る", send: "送信", close: "閉じる", cancel: "キャンセル",
    report_reasons: ["スパム・詐欺", "著作権侵害", "不適切な内容", "その他"],
  },
  EN: {
    gov: "Ikemoto City  Digital Office",
    sub: "IKEMOTO CITY DIGITAL GOVERNMENT",
    tab_board: "BOARD", tab_market: "MARKET", tab_gov: "GOV", tab_proc: "PROC", tab_my: "MY PAGE",
    board_title: "Co-creation Board", board_sub: "Co-creation Board",
    board_note: "Participation is only through skill assignment.",
    board_msg_tab: "Messages", board_board_tab: "Board",
    board_assign_btn: "Apply for Assignment", board_room_btn: "Enter Project Room",
    board_closed: "This project is no longer accepting applications",
    board_my_msg: "MY PROJECT MESSAGES", board_no_room: "No active project rooms",
    board_no_room_sub: "Apply for a project to see your rooms here",
    board_back: "\u2190 Back to Board", board_chat_to: "Chat \u2192",
    market_list_title: "Shop List", market_shops: "shops",
    market_items: "items", market_go: "View Shop \u2192", market_back: "\u2190 Shops",
    market_assets: "Assets", market_report_title: "Report Shop",
    market_report_send: "Send", market_report_done: "Report received",
    market_report_done_sub: "We will review and take action.",
    market_follow: "Follow", market_following: "Following",
    market_like: "Like", market_liked: "Liked",
    market_report: "Report", market_block: "Block",
    market_price: "Price",
    gov_title: "Administration", gov_sub: "Administration",
    gov_treasury: "Treasury", gov_citizens: "Citizen Stats",
    proc_title: "Procedures", proc_sub: "Procedures",
    proc_apply: "Apply", proc_status: "Status",
    my_title: "My Page", my_settings: "Settings",
    my_logout: "Logout", my_following: "Following",
    my_liked: "Liked", my_blocked: "Blocked List",
    my_liked_shops: "Liked Shops", my_liked_items: "Liked Assets",
    my_inquiry: "Submit Feedback",
    back: "\u2190 Back", send: "Send", close: "Close", cancel: "Cancel",
    report_reasons: ["Spam / Fraud", "Copyright", "Inappropriate", "Other"],
  },
  "\u97d3": {
    gov: "\uc774\ucf00\ubaa8\ud1a0\uc2dc  \ub514\uc9c0\ud138\uc2dc\uccad",
    sub: "IKEMOTO CITY DIGITAL GOVERNMENT",
    tab_board: "\uac8c\uc2dc\ud310", tab_market: "\uc2dc\uc7a5", tab_gov: "\ud589\uc815", tab_proc: "\uc808\ucc28", tab_my: "\ub9c8\uc774\ud398\uc774\uc9c0",
    board_title: "\uacf5\ub3d9\ucc3d\uc870 \uac8c\uc2dc\ud310", board_sub: "Co-creation Board",
    board_note: "\uc0b0\ub2e4",
    board_msg_tab: "\uba54\uc2dc\uc9c0", board_board_tab: "\uac8c\uc2dc\ud310",
    board_assign_btn: "\uc815\uc6d0 \uc2e0\uccad", board_room_btn: "\ud504\ub85c\uc81d\ud2b8 \ub8f8\uc73c\ub85c",
    board_closed: "\ubaa8\uc9d1\uc774 \ub9c8\uac10\ub418\uc5c8\uc2b5\ub2c8\ub2e4",
    board_my_msg: "\ub098\uc758 \ud504\ub85c\uc81d\ud2b8", board_no_room: "\ucc38\uc5ec\uc218\uc778 \ub8f8\ubc29\uc774 \uc5c6\uc2b5\ub2c8\ub2e4",
    board_no_room_sub: "\ud504\ub85c\uc81d\ud2b8\uc5d0 \uc2e0\uccad\ud558\uba74 \uc774\uacf3\uc5d0 \ud45c\uc2dc\ub429\ub2c8\ub2e4",
    board_back: "\u2190 \uac8c\uc2dc\ud310\uc73c\ub85c", board_chat_to: "\ucc44\ud305\uc73c\ub85c \u2192",
    market_list_title: "\uc2dc\uc7a5 \uc0c1\uc810 \ubaa9\ub85d", market_shops: "\uc0c1\uc810",
    market_items: "\uac74", market_go: "\uc0c1\uc810 \ubcf4\uae30 \u2192", market_back: "\u2190 \ubaa9\ub85d",
    market_assets: "\uc790\uc0b0", market_report_title: "\uc2e0\uace0",
    market_report_send: "\uc804\uc1a1", market_report_done: "\uc2e0\uace0\ub97c \uc811\uc218\ud588\uc2b5\ub2c8\ub2e4",
    market_report_done_sub: "\ud655\uc778 \ud6c4 \uc870\uce58\ud558\uaca0\uc2b5\ub2c8\ub2e4.",
    market_follow: "\ud314\ub85c\uc6b0", market_following: "\ud314\ub85c\uc789",
    market_like: "\uc88b\uc544\uc694", market_liked: "\uc88b\uc544\uc694\uc911",
    market_report: "\uc2e0\uace0", market_block: "\ucc28\ub2e8",
    market_price: "\uac00\uaca9",
    gov_title: "\ud589\uc815", gov_sub: "Administration",
    gov_treasury: "\uc7ac\uc815", gov_citizens: "\uc2dc\ubbfc \ud1b5\uacc4",
    proc_title: "\uc808\ucc28", proc_sub: "Procedures",
    proc_apply: "\uc2e0\uccad", proc_status: "\uc0c1\ud0dc",
    my_title: "\ub9c8\uc774\ud398\uc774\uc9c0", my_settings: "\uc124\uc815",
    my_logout: "\ub85c\uadf8\uc544\uc6c3", my_following: "\ud314\ub85c\uc789",
    my_liked: "\uc88b\uc544\uc694", my_blocked: "\ucc28\ub2e8 \ubaa9\ub85d",
    my_liked_shops: "\uc88b\uc544\uc694 \uc0c1\uc810", my_liked_items: "\uc88b\uc544\uc694 \uc790\uc0b0",
    my_inquiry: "\uc758\uacac \uc81c\ucd9c",
    back: "\u2190 \ub4a4\ub85c", send: "\uc804\uc1a1", close: "\ub2eb\uae30", cancel: "\ucde8\uc18c",
    report_reasons: ["\uc2a4\ud338/\uc0ac\uae30", "\uc800\uc791\uad8c\uce68\ud574", "\ubd80\uc801\uc808", "\uae30\ud0c0"],
  },
  "\u4e2d": {
    gov: "\u6c60\u672c\u5e02  \u6570\u5b57\u5e02\u653f\u5385",
    sub: "IKEMOTO CITY DIGITAL GOVERNMENT",
    tab_board: "\u516c\u544a\u680f", tab_market: "\u5546\u4e1a\u533a", tab_gov: "\u884c\u653f", tab_proc: "\u624b\u7eed", tab_my: "\u6211\u7684\u9875\u9762",
    board_title: "\u5171\u521b\u516c\u544a\u680f", board_sub: "Co-creation Board",
    board_note: "\u53c2\u4e0e\u9700\u901a\u8fc7\u6280\u80fd\u5206\u914d\u3002",
    board_msg_tab: "\u6d88\u606f", board_board_tab: "\u516c\u544a\u680f",
    board_assign_btn: "\u7533\u8bf7\u5206\u914d", board_room_btn: "\u8fdb\u5165\u9879\u76ee\u623f\u95f4",
    board_closed: "\u672c\u9879\u76ee\u5df2\u505c\u6b62\u62db\u52df",
    board_my_msg: "\u6211\u7684\u9879\u76ee", board_no_room: "\u6682\u65e0\u53c2\u4e0e\u7684\u9879\u76ee\u623f\u95f4",
    board_no_room_sub: "\u7533\u8bf7\u9879\u76ee\u5206\u914d\u540e\u53ef\u5728\u6b64\u67e5\u770b",
    board_back: "\u2190 \u8fd4\u56de\u516c\u544a\u680f", board_chat_to: "\u804a\u5929 \u2192",
    market_list_title: "\u5546\u4e1a\u533a \u5e97\u94fa\u5217\u8868", market_shops: "\u5bb6\u5e97",
    market_items: "\u4ef6", market_go: "\u67e5\u770b\u5e97\u94fa \u2192", market_back: "\u2190 \u5217\u8868",
    market_assets: "\u8d44\u4ea7", market_report_title: "\u4e3e\u62a5\u5e97\u94fa",
    market_report_send: "\u53d1\u9001", market_report_done: "\u4e3e\u62a5\u5df2\u5904\u7406",
    market_report_done_sub: "\u6838\u5b9e\u540e\u5904\u7406\u3002",
    market_follow: "\u5173\u6ce8", market_following: "\u5df2\u5173\u6ce8",
    market_like: "\u70b9\u8d5e", market_liked: "\u5df2\u70b9\u8d5e",
    market_report: "\u4e3e\u62a5", market_block: "\u5c4f\u853d",
    market_price: "\u4ef7\u683c",
    gov_title: "\u884c\u653f\u4fe1\u606f", gov_sub: "Administration",
    gov_treasury: "\u8d22\u52a1", gov_citizens: "\u5e02\u6c11\u7edf\u8ba1",
    proc_title: "\u884c\u653f\u624b\u7eed", proc_sub: "Procedures",
    proc_apply: "\u7533\u8bf7", proc_status: "\u72b6\u6001",
    my_title: "\u6211\u7684\u9875\u9762", my_settings: "\u8bbe\u7f6e",
    my_logout: "\u767b\u51fa", my_following: "\u5df2\u5173\u6ce8",
    my_liked: "\u5df2\u70b9\u8d5e", my_blocked: "\u5c4f\u853d\u5217\u8868",
    my_liked_shops: "\u5df2\u8d5e\u5e97\u94fa", my_liked_items: "\u5df2\u8d5e\u8d44\u4ea7",
    my_inquiry: "\u63d0\u4ea4\u610f\u89c1",
    back: "\u2190 \u8fd4\u56de", send: "\u53d1\u9001", close: "\u5173\u95ed", cancel: "\u53d6\u6d88",
    report_reasons: ["\u5783\u573e/\u8bc8\u9a97", "\u7248\u6743\u4fb5\u6743", "\u4e0d\u5f53\u5185\u5bb9", "\u5176\u4ed6"],
  },
  ES: {
    gov: "Ciudad Ikemoto  Oficina Digital",
    sub: "IKEMOTO CITY DIGITAL GOVERNMENT",
    tab_board: "TABL\u00d3N", tab_market: "MERCADO", tab_gov: "GOB", tab_proc: "TR\u00c1MITE", tab_my: "MI P\u00c1G",
    board_title: "Tablero Co-creaci\u00f3n", board_sub: "Co-creation Board",
    board_note: "La participaci\u00f3n es solo por asignaci\u00f3n de habilidades.",
    board_msg_tab: "Mensajes", board_board_tab: "Tabl\u00f3n",
    board_assign_btn: "Solicitar asignaci\u00f3n", board_room_btn: "Sala de Proyecto",
    board_closed: "Este proyecto ya no acepta solicitudes",
    board_my_msg: "MIS PROYECTOS", board_no_room: "Sin salas de proyecto activas",
    board_no_room_sub: "Solicita un proyecto para ver tus salas aqu\u00ed",
    board_back: "\u2190 Volver", board_chat_to: "Chat \u2192",
    market_list_title: "Lista de Tiendas", market_shops: "tiendas",
    market_items: "art\u00edculos", market_go: "Ver tienda \u2192", market_back: "\u2190 Tiendas",
    market_assets: "Activos", market_report_title: "Reportar tienda",
    market_report_send: "Enviar", market_report_done: "Reporte recibido",
    market_report_done_sub: "Revisaremos y actuaremos.",
    market_follow: "Seguir", market_following: "Siguiendo",
    market_like: "Me gusta", market_liked: "Te gusta",
    market_report: "Reportar", market_block: "Bloquear",
    market_price: "Precio",
    gov_title: "Administraci\u00f3n", gov_sub: "Administration",
    gov_treasury: "Tesorer\u00eda", gov_citizens: "Estad\u00edsticas",
    proc_title: "Tr\u00e1mites", proc_sub: "Procedures",
    proc_apply: "Solicitar", proc_status: "Estado",
    my_title: "Mi P\u00e1gina", my_settings: "Ajustes",
    my_logout: "Cerrar sesi\u00f3n", my_following: "Siguiendo",
    my_liked: "Me gusta", my_blocked: "Bloqueados",
    my_liked_shops: "Tiendas favoritas", my_liked_items: "Activos favoritos",
    my_inquiry: "Enviar opini\u00f3n",
    back: "\u2190 Volver", send: "Enviar", close: "Cerrar", cancel: "Cancelar",
    report_reasons: ["Spam/Fraude", "Derechos de autor", "Inapropiado", "Otro"],
  },
};

export function useI18n(lang) {
  return translations[lang] || translations["JP"];
}

export default translations;
